import api from '../utils/apiClient';

export const ADMIN_BROADCAST_NOTIFICATION_PATH = '/api/admin/notifications/broadcast';

/**
 * Broadcast a push notification via the universal admin backend.
 * @param {{ title: string; body: string; data?: Record<string, unknown>; appSlugs?: string[] }} payload
 *   Pass appSlugs array to target specific apps, or omit/empty for all apps.
 */
export async function broadcastAdminNotification(payload) {
  const { title, body, data, appSlugs } = payload;
  const res = await api.post(
    ADMIN_BROADCAST_NOTIFICATION_PATH,
    {
      title: typeof title === 'string' ? title.trim() : '',
      body: typeof body === 'string' ? body.trim() : '',
      data: data && typeof data === 'object' ? data : {},
      appSlugs: Array.isArray(appSlugs) && appSlugs.length ? appSlugs : [],
    },
    {
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    }
  );
  return res.data;
}
